import * as React from 'react';
import { Button, Col, Container, Row } from 'reactstrap';
import { TR } from 'src/TextRes';
import {
    ApiCourseProvidersActivate,
    ApiCourseProvidersCommission,
    ApiCourseProvidersCsv,
    ApiCourseProvidersDeactivate,
    ApiCourseProvidersDelete,
    ApiCourseProvidersFastbill,
    ApiCourseProvidersList,
    CourseProviderListLine,
    CourseProviderListParams,
    ServerResponse,
} from '../../api';
import EditableInput from '../../components/editableInput/EditableInput';
import FAIcon from '../../components/fAIcon/FAIcon';
import Footer from '../../components/footer/Footer';
import HeaderLoggedIn from '../../components/headerLoggedIn/HeaderLoggedIn';
import { ModalMessage } from '../../components/modalMessage/ModalMessage';
import { ModalMessageToEmail } from '../../components/modalMessageToEmail/ModalMessageToEmail';
import NetworkOverlay from '../../components/networkOverlay/NetworkOverlay';
import Paging from '../../components/paging/Paging';
import { IThConfig, SortableTh } from '../../components/sortableTh/SortableTh';
import { TableBox } from '../../components/tableBox/TableBox';
import { IEmptyProps, ISortIcon } from '../../constants';
import './AdminAllCourseProvider.css';

interface IState {
    loading: boolean;
    listData: CourseProviderListLine[];
    openModalMessage: boolean;
    openDeleteDialog: boolean;
    serverResponse?: ServerResponse;
    searchParams: CourseProviderListParams;
    sortIcon: ISortIcon[];
    totalCount: number;
    emailToCourseProvider: string;
    courseProviderID: string;
    courseProviderMail: string;
    courseProviderName: string;
    courseProviderActive: boolean;
    currentlyCommissionEditing: string | undefined;
    currentlyFastBillEditing: string | undefined;
}

export default class AdminAllCourseProvider extends React.Component<IEmptyProps, IState> {
    private renderTHeadLineArrays: IThConfig[] = [
        { sortField: 'name', name: 'Kursanbieter', width: '20%' },
        { sortField: 'street', name: 'Adresse', width: '25%' },
        { name: 'Aktive Kurse', width: '10%' },
        { name: 'Status', width: '10%' },
        { sortField: 'fastbillID', name: 'FastbillID', width: '10%' },
        { sortField: 'commission', name: 'Tarif', width: '10%' },
        { sortField: 'insertDate', name: 'Registriert am', width: '10%' },
        { sortField: 'disabled', name: 'Aktiv', width: '6%' },
    ];
    constructor(props: IEmptyProps) {
        super(props);
        this.state = {
            courseProviderActive: false,
            courseProviderID: '',
            courseProviderMail: '',
            courseProviderName: '',
            currentlyCommissionEditing: undefined,
            currentlyFastBillEditing: undefined,
            emailToCourseProvider: '',
            listData: [],
            loading: true,
            openModalMessage: false,
            openDeleteDialog: false,
            searchParams: {
                Descending: true,
                Offset: 0,
                PageSize: 25,
                Search: '',
                Sort: 'insertDate',
            },
            serverResponse: undefined,
            sortIcon: [],
            totalCount: 0,
        };
    }

    public componentDidMount() {
        const mySortIcon = this.state.sortIcon;
        this.renderTHeadLineArrays.map(() => {
            mySortIcon.push(0);
        });
        this.setState({ sortIcon: [...mySortIcon] }, () => {
            this.searchCourseProviders();
        });
    }

    public render() {
        const renderTHeadLine = (
            <tr>
                {this.renderTHeadLineArrays.map((str: IThConfig, index: number) => {
                    return (
                        <SortableTh
                            key={str.name}
                            index={index}
                            sortIcon={this.state.sortIcon[index]}
                            sortField={str.sortField}
                            onClickSorting={this.onClickSorting}
                            widthStyle={str.width}
                            name={str.name}
                        />
                    );
                })}
            </tr>
        );
        const {
            courseProviderActive,
            courseProviderMail,
            loading,
            openModalMessage,
            openDeleteDialog,
            courseProviderName,
            searchParams,
            serverResponse,
            totalCount,
        } = this.state;

        return (
            <NetworkOverlay loading={loading} serverResponse={serverResponse}>
                <HeaderLoggedIn />
                <Container>
                    <Row>
                        <Col className={'searchLine'}>
                            <div>
                                <input
                                    name="CourseNameSearching"
                                    type="text"
                                    placeholder={TR.adminAllCourseProvider_search}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        this.changeValue('Search', e.target.value, true, true);
                                    }}
                                />
                            </div>

                            <div className={'text-right'}>
                                <Button size="sm" color="danger" onClick={ApiCourseProvidersCsv}>
                                    <span>{TR.adminAllCourseProvider_csv_export}</span>
                                </Button>
                            </div>
                        </Col>
                    </Row>
                    {!loading && (
                        <Row className="mt-5">
                            <Col>
                                <TableBox
                                    listData={this.state.listData}
                                    renderTHeadLine={renderTHeadLine}
                                    renderTBodyLine={this.renderTBodyLine}
                                />
                                <Paging
                                    totalCount={totalCount}
                                    pageSize={searchParams.PageSize}
                                    offset={searchParams.Offset}
                                    changeValue={this.changeValue}
                                />
                            </Col>
                        </Row>
                    )}
                </Container>
                <ModalMessageToEmail
                    isOpen={openModalMessage}
                    modalHeader={courseProviderActive ? 'Kursanbieter aktivieren?' : 'Kursanbieter deaktivieren?'}
                    modalBody={`E-Mail an: ${courseProviderMail}`}
                    onClickYes={this.onClickEmailThat}
                    onClickNo={this.closeModal}
                    eMailToCourseProvider={(e: React.ChangeEvent<HTMLInputElement>) => {
                        this.setState({ emailToCourseProvider: e.target.value });
                    }}
                />
                <ModalMessage
                    isOpen={openDeleteDialog}
                    modalHeader={TR.adminAllCourseProvider_really_delete}
                    modalBody={`${TR.adminAllCourseProvider_do_you_want} ${courseProviderName} ${TR.adminAllCourseProvider_reallly_delete}`}
                    onClickYes={this.onDeleteCourseProvider}
                    onClickNo={() => {
                        this.setState({ openDeleteDialog: false, courseProviderID: '', courseProviderName: '' });
                    }}
                />
                <Footer />
            </NetworkOverlay>
        );
    }

    private searchCourseProviders = () => {
        ApiCourseProvidersList({ ...this.state.searchParams }, (sr) => {
            if (sr.OK) {
                this.setState({
                    listData: sr.Data ? sr.Data.Lines : [],
                    loading: false,
                    serverResponse: sr,
                    totalCount: sr.Data ? sr.Data.Count : 0,
                });
            } else {
                this.setState({ serverResponse: sr });
            }
        });
    };

    private renderTBodyLine = (value: CourseProviderListLine, index: number) => {
        // const cn = 'numberCircle c' + value.Commission;
        let status = TR.adminAllCourseProvider_not_confirmed;
        if (value.Status === 'active') {
            status = TR.adminAllCourseProvider_active;
        }
        if (value.Status === 'hasCourses') {
            status = TR.adminAllCourseProvider_has_courses;
        }
        if (value.Deleted) {
            status = TR.adminAllCourseProvider_deleted;
        }

        return (
            <tr key={value.CourseProviderID} className={'adminallcourseprovider'}>
                <td>
                    <a href={value.PublicUrl} target="blank">
                        {value.Name}
                    </a>
                </td>
                <td>{value.Address}</td>
                <td>{value.ActiveCourses}</td>
                <td>{status}</td>
                <td>
                    <EditableInput
                        disabled={value.Deleted}
                        maxLength={10}
                        value={value.FastbillID}
                        cancelHandler={() => this.setState({ currentlyFastBillEditing: undefined })}
                        saveHandler={(a: string) => {
                            this.saveFastBillID(a, value.CourseProviderID);
                        }}
                        editHandler={() => {
                            this.setState({
                                currentlyCommissionEditing: undefined,
                                currentlyFastBillEditing: value.CourseProviderID,
                            });
                        }}
                        editItemKey={this.state.currentlyFastBillEditing}
                        editName={value.CourseProviderID}
                    />
                </td>
                <td>
                    <EditableInput
                        disabled={value.Deleted}
                        maxLength={4}
                        value={value.Commission.toLocaleString('de-DE', {
                            maximumFractionDigits: 1,
                            minimumFractionDigits: 1,
                            useGrouping: false,
                        })}
                        cancelHandler={() => this.setState({ currentlyCommissionEditing: undefined })}
                        saveHandler={(a: string) => {
                            this.saveCommission(a, value.CourseProviderID);
                        }}
                        editHandler={() => {
                            this.setState({
                                currentlyFastBillEditing: undefined,
                                currentlyCommissionEditing: value.CourseProviderID,
                            });
                        }}
                        editItemKey={this.state.currentlyCommissionEditing}
                        editName={value.CourseProviderID}
                    />
                </td>
                <td>{value.InsertDate}</td>
                <td>
                    {value.Disabled && (
                        <>
                            <a
                                onClick={(e: React.SyntheticEvent) => {
                                    if (!value.Deleted) {
                                        this.openModal(e);
                                        this.setState({ courseProviderActive: true, openModalMessage: true });
                                    }
                                }}
                                data-mail={value.Email}
                                data-cid={value.CourseProviderID}
                            >
                                <FAIcon mouseHover="aktivieren" icon="circle" className="banned" />
                            </a>
                            {!value.Deleted && (
                                <FAIcon
                                    mouseHover="löschen"
                                    icon="trash"
                                    onClick={() => {
                                        this.setState({
                                            openDeleteDialog: true,
                                            courseProviderID: value.CourseProviderID,
                                            courseProviderName: value.Name,
                                        });
                                    }}
                                />
                            )}
                        </>
                    )}
                    {!value.Disabled && (
                        <a
                            onClick={(e: React.SyntheticEvent) => {
                                this.openModal(e);
                                this.setState({ courseProviderActive: false, openModalMessage: true });
                            }}
                            data-mail={value.Email}
                            data-cid={value.CourseProviderID}
                        >
                            <FAIcon mouseHover="deaktivieren" icon="circle" />
                        </a>
                    )}
                </td>
            </tr>
        );
    };

    private saveCommission = (a: string, id: string) => {
        this.setState({
            currentlyCommissionEditing: undefined,
            loading: true,
        });
        a = a.replace(/[,]/g, '.');
        const neuCommission: number = Number.parseFloat(a);
        ApiCourseProvidersCommission({ ID: id, Commission: Math.abs(neuCommission) }, (sr: ServerResponse) => {
            this.searchCourseProviders();
        });
    };

    private saveFastBillID = (a: string, id: string) => {
        this.setState({
            currentlyFastBillEditing: undefined,
            loading: true,
        });
        ApiCourseProvidersFastbill({ ID: id, FastBill: a }, (sr: ServerResponse) => {
            this.searchCourseProviders();
        });
    };

    private onClickSorting = (sortField: string, index: number, sortIcon: ISortIcon) => {
        this.changeValue('Sort', sortField, true);
        const mySortIcon: ISortIcon[] = [];
        this.state.sortIcon.map(() => mySortIcon.push(0));
        mySortIcon[index] = sortIcon;
        if (sortIcon === ISortIcon.Sort) {
            mySortIcon[index] = ISortIcon.SortUp;
            this.setState({ sortIcon: [...mySortIcon] }, () => {
                this.changeValue('Sort', sortField, true);
                this.changeValue('Descending', false, true);
            });
        }
        if (sortIcon === ISortIcon.SortUp) {
            mySortIcon[index] = ISortIcon.SortDown;
            this.setState({ sortIcon: [...mySortIcon] }, () => {
                this.changeValue('Sort', sortField, true);
                this.changeValue('Descending', true, true);
            });
        }
        if (sortIcon === ISortIcon.SortDown) {
            mySortIcon[index] = ISortIcon.SortUp;
            this.setState({ sortIcon: [...mySortIcon] }, () => {
                this.changeValue('Sort', sortField, true);
                this.changeValue('Descending', false, true);
            });
        }
    };

    private changeValue = (
        fieldName: string,
        value: string | boolean | number,
        reload: boolean = false,
        resetPaging: boolean = false
    ) => {
        const newParams = { ...this.state.searchParams };
        newParams[fieldName] = value;
        if (resetPaging) {
            newParams.Offset = 0;
        }
        if (reload) {
            this.setState(
                { searchParams: newParams, currentlyCommissionEditing: undefined, currentlyFastBillEditing: undefined },
                this.searchCourseProviders
            );
        } else {
            this.setState({ searchParams: newParams });
        }
    };

    private activateCourseProvider = () => {
        this.setState({ loading: true, openModalMessage: false }, () => {
            ApiCourseProvidersActivate(
                { ID: this.state.courseProviderID, EmailMessage: this.state.emailToCourseProvider },
                (sr: ServerResponse) => {
                    this.searchCourseProviders();
                }
            );
        });
    };

    private deactivateCourseProvider = () => {
        this.setState({ loading: true, openModalMessage: false }, () => {
            ApiCourseProvidersDeactivate(
                { ID: this.state.courseProviderID, EmailMessage: this.state.emailToCourseProvider },
                (sr: ServerResponse) => {
                    this.searchCourseProviders();
                }
            );
        });
    };

    private onClickEmailThat = () => {
        if (this.state.courseProviderActive) {
            this.activateCourseProvider();
        } else {
            this.deactivateCourseProvider();
        }
    };

    private onDeleteCourseProvider = () => {
        this.setState({ loading: true, openDeleteDialog: false }, () => {
            ApiCourseProvidersDelete({ ID: this.state.courseProviderID }, (sr: ServerResponse) => {
                this.setState({ courseProviderID: '', courseProviderName: '' }, this.searchCourseProviders);
            });
        });
    };

    private openModal = (e: React.SyntheticEvent) => {
        const cid = e.currentTarget.getAttribute('data-cid');
        const mail = e.currentTarget.getAttribute('data-mail');
        if (cid && mail) {
            this.setState({
                courseProviderID: cid,
                courseProviderMail: mail,
            });
        }
    };

    private closeModal = () => {
        this.setState({ openModalMessage: false });
    };
}



// WEBPACK FOOTER //
// ./src/views/adminAllCourseProvider/AdminAllCourseProvider.tsx